import React from 'react';
import PropTypes from 'prop-types';
import QuestionnaireGeneralDataContainer from './generalData/QuestionnaireGeneralDataContainer';
import QuestionsContainer from './questions/QuestionsContainer';
import QuestionActionsContainer from './questionActions/QuestionActionsContainer';
import { FakeText, Card } from '@totalsoft/rocket-ui';
import { QUESTIONNAIRE_QUERY } from '../../queries';
import { useQuery } from 'hooks/apollo';

const QuestionnaireContainer = ({ questionnaireId, onChangeQuestionnaireTitle, onRedirect }) => {
  const { data, loading: questionnaireLoading } = useQuery(QUESTIONNAIRE_QUERY, {
    variables: {
      questionnaireId: questionnaireId
    },
    skip: !questionnaireId
  });

  const isReadOnly = data && data.questionnaire ? data.questionnaire.isHistory : false;

  return questionnaireLoading ? (
    <Card>
      <FakeText lines={10} />
    </Card>
  ) : (
    <>
      <QuestionnaireGeneralDataContainer
        questionnaireId={questionnaireId}
        data={data?.questionnaire}
        onChangeQuestionnaireTitle={onChangeQuestionnaireTitle}
        onRedirect={onRedirect}
        isReadOnly={isReadOnly}
      />
      {questionnaireId !== null && questionnaireId !== undefined && (
        <QuestionActionsContainer
          questionnaireId={questionnaireId}
          data={data && data.questionnaire ? data.questionnaire.questionActions : []}
          isReadOnly={isReadOnly}
        />
      )}
      {questionnaireId !== null && questionnaireId !== undefined && (
        <QuestionsContainer
          questionnaireId={questionnaireId}
          data={data && data.questionnaire ? data.questionnaire.questions : []}
          isReadOnly={isReadOnly}
        />
      )}
    </>
  );
};

QuestionnaireContainer.propTypes = {
  questionnaireId: PropTypes.number,
  onChangeQuestionnaireTitle: PropTypes.func,
  onRedirect: PropTypes.func
};

export default QuestionnaireContainer;
